export class LogLevel {
    None = 0;
    Info = 1;
    Verbose = 2;
    Warn = 3;
    Error = 4;
    req=5;
    res=6;
  constructor() { }
  }